export default "__VITE_ASSET__Cq5Wwzgw__"